"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Search = void 0;
var React = __importStar(require("react"));
var react_1 = require("@chakra-ui/react");
var SearchButton_1 = require("./SearchButton");
var SearchBar_1 = require("./SearchBar");
var Search = function (_a) {
    var accountMenuProps = _a.accountMenuProps;
    var showInlineSearchBar = (0, react_1.useBreakpointValue)({ base: false, xl: true, fallback: false });
    return showInlineSearchBar ? React.createElement(SearchBar_1.SearchBar, { maxW: 48 }) : React.createElement(SearchButton_1.SearchButton, null);
};
exports.Search = Search;
